import { z } from 'zod';

import { CompanyId, CustomTemplateId, UserId } from '../BrandedIds';
import { zodBrandedUuid, zodDateOrString } from '../utils/Zod';

export const CustomTemplate = z.object({
  id: zodBrandedUuid<CustomTemplateId>(),
  name: z.string(),
  carboneTemplateId: z.string().min(1),
  companyId: zodBrandedUuid<CompanyId>(),
  createdById: zodBrandedUuid<UserId>(),
  version: z.number().int().min(0),
  createdAt: zodDateOrString,
  updatedAt: zodDateOrString,
});
export type CustomTemplate = z.infer<typeof CustomTemplate>;

export const CustomTemplateInput = CustomTemplate.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
});
export type CustomTemplateInput = z.infer<typeof CustomTemplateInput>;
